import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Button from "../../../../modules/commons/Button";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleInput from "../../../../modules/SimpleInput";
import MasterLogistikTable from "../common/masterLogistikTable";
import {formGroupWarna, tableConfig} from "../config";
import MasterLogistikMotorWarnaModifying from "./modal/MasterLogistikMotorWarnaModifying";
import MasterLogistikMotorWarnaFilter from "./modal/MasterLogistikMotorWarnaFilter";
import Api from "../../../../Services/Api";
import {flattenFormGroupObject, getValueFromDDL, mapToObjectDDL, removeNullFields} from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {checkAndHandleError, convertFileToBase64, fetchDataAsync} from "../../../../Services/Utils";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import {HttpStatus} from "../../../common/Constants";
import SimpleUploadExcel from "../../../../modules/upload/SimpleUploadExcel";
import {saveAs} from "file-saver"
class MasterLogistikMotorWarna extends Component {
    constructor(props) {
        super(props);
        this.tableConfig = tableConfig.warna;
        this.initialData = {
            id: null,
            idWarna: null,
            kodeWarna: null,
            namaWarnaPabrik: null,
            namaWarnaKomersil: null,
            kodeVariant: null,
            discontinue: null,
        };
        this.initialSearch = {
            kodeVariant: null,
        };
        this.state = {
            filterModalVisible: false,
            modifyingVisible: false,
            uploadModalVisible: false,
            file: null,
            selectedData: null,
            filterData: this.initialData,
            search: this.initialSearch,
            submittedFilterData: {},
            dataVariantDDL: [],
            dataTable: [],
            pagination: {
                count: 10,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            }
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchDataWarna();
        this.handleTriggerLoading();
    }

    handleModalFilterVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterModalVisible: !prevState.filterModalVisible,
        }));
    };

    handleModifyingModalVisibility = async (index) => {
        this.handleTriggerLoading();
        if (!this.state.modifyingVisible) {
            await this.fetchDataVariant();
        }

        if (!R.isNil(index)) {
            try {
                let res = await Api.create("NAGAMAS_MASTER_DATA").getWarnaById(this.state.dataTable[index].id);
                if (res.ok) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        selectedData: {
                            ...res.data.data.warnaResponseDTO,
                            kodeVariant: mapToObjectDDL(
                                res.data.data.kodeVariant + " - " + res.data.data.namaVariant,
                                res.data.data.kodeVariant
                            ),
                            discontinue: mapToObjectDDL(
                                res.data.data.warnaResponseDTO.discontinue ? "YES" : "NO",
                                res.data.data.warnaResponseDTO.discontinue
                            ),
                        },
                        modifyingVisible: !prevValue.modifyingVisible,
                    }));
                } else {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        selectedData: {...prevValue.dataTable[index]},
                        modifyingVisible: !prevValue.modifyingVisible,
                    }));
                }
            } catch (error) {
                console.log("errors: ", error);
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }

        this.handleTriggerLoading();
    };

    handleUploadModalVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            uploadModalVisible: !prevValue.uploadModalVisible
        }));
    }

    handleSubmitModifying = async (controls) => {
        this.handleTriggerLoading();
        const formGroup = flattenFormGroupObject(controls);
        const requestBody = {
            ...formGroup,
            kodeVariant: getValueFromDDL(formGroup, "kodeVariant"),
            discontinue: getValueFromDDL(formGroup, "discontinue"),
        };

        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").saveWarna,
            requestBody,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleResetAllFilters();
            this.handleModifyingModalVisibility();
            const { pagination, submittedFilterData } = this.state
            await this.fetchDataWarna({
                paramFilters: submittedFilterData,
                page: pagination.page,
                limit: pagination.limit
            });
        }
        this.handleTriggerLoading();
    };

    handleSubmitFilter = async () => {
        this.handleTriggerLoading();
        this.handleClearSearch();
        let req = {
            paramFilters: removeNullFields(this.parseFilterData(this.state.filterData)),
            limit: 5,
            page: 1
        };
        this.handleChangeSubmittedFilterData(req.paramFilters);
        this.handleModalFilterVisibility();
        await this.fetchDataWarna(req);
        this.handleTriggerLoading();

    };

    handleSearch = async () => {
        this.handleTriggerLoading();
        this.handleClearForm();
        let req = {
            paramFilters: removeNullFields(this.state.search),
            limit: 5,
            page: 1
        }
        this.handleChangeSubmittedFilterData(req.paramFilters);
        await this.fetchDataWarna(req);
        this.handleTriggerLoading();
    }

    handleChangeStatus = async (index, value) => {
        this.handleTriggerLoading();
        let data = this.state.dataTable[index];
        data.status = value ? "ACTIVE" : "INACTIVE";
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").updateStatusWarna,
            data,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleResetAllFilters();
            const { pagination, submittedFilterData } = this.state
            await this.fetchDataWarna({
                paramFilters: submittedFilterData,
                page: pagination.page,
                limit: pagination.limit
            });
        }
        this.handleTriggerLoading();
    };

    handleFilterValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
    };

    handleClearForm = () => {
        this.setState((prevValue) => ({...prevValue, filterData: this.initialData}));
    };

    handleClearSearch = () => {
        this.setState((prevValue) => ({...prevValue, search: this.initialSearch}));
    };

    handleUpload = async(file) => {
        try {
            this.handleTriggerLoading();
            const renamedFile = new File([file], "WARNA.xlsx", {
                type: file.type,
            });

            const formData = new FormData();
            formData.append("file", renamedFile);

            let res = await Api.create("NAGAMAS_MASTER_DATA").uploadExcelWarna(formData);
            if (res.ok) {
                if (res.data.status === HttpStatus.FAILED && res.data.code === 503) {
                    this.handleTriggerLoading();
                    return checkAndHandleError(res, this.props.setError, "Master Logistik Motor - Varian");
                }
                if (res.data.status === HttpStatus.SUCCESS) {
                    this.handleTriggerLoading();
                    return true;
                }
            }
        } catch (e) {
            console.log("error: ", e);
        }
        this.handleTriggerLoading();
        return false;
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleChangePage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);
        let {submittedFilterData} = this.state;
        await this.fetchDataWarna({
            paramFilters: submittedFilterData,
            page: page,
            limit: limit
        });
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);
        let {submittedFilterData} = this.state;
        await this.fetchDataWarna({
            paramFilters: submittedFilterData,
            page: page,
            limit: limit
        });
        this.handleTriggerLoading();
    }

    fetchDataWarna = async (body) => {
        this.setState((prevState) => ({...prevState, pagination: {...prevState.pagination, count: 0}}));
        let req = body && Object.keys(body).length > 0
            ? body :
            {
                paramFilters: {},
                page: 1,
                limit: 5,
            };
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByParam,
            req,
        );

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataTable: res.data.data,
                pagination: {
                    ...prevState.pagination,
                    count: res.data.totalData,
                    page: req.page,
                    limit: req.limit,
                }
            }));
        }
    }

    fetchDataVariant = async () => {
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataVariantDDL: res.data.data.map(item => mapToObjectDDL(
                    item.kodeVariant + " - " + item.namaVariant,
                    item.kodeVariant
                )),
            }));
        }
    }

    parseFilterData(data) {
        return {
            ...data,
            discontinue: getValueFromDDL(data, "discontinue"),
        };
    }

    callApi = async (api, args) => {
        return await fetchDataAsync({
            asyncFn: api,
            menuName: "Master Logistik Motor - Warna",
            setError: this.props.setError,
            args: args,
        })
    };

    handleChangeSubmittedFilterData = (data) => {
        this.setState((prevState) => ({
            ...prevState,
            submittedFilterData: data,
        }));
    };

    handleResetAllFilters = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterData: this.initialData,
            search: this.initialSearch,
            submittedFilterData: {},
        }));
    };

    handleDownloadTemplate = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA_FILE").downloadTemplateWarna();
            if (res.ok) {
                if (checkAndHandleError(res, this.props.setError, "Master Logistik Motor - Warna")) return;
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "TEMPLATE_UPLOAD_WARNA.xlsx";
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        } catch (err) {
            console.log("error: ", err);
        }
    };

    handleDownloadLogError = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA_FILE").downloadErrorLogWarna();
            if (res.ok) {
                if (checkAndHandleError(res, this.props.setError, "Master Logistik Motor - Warna")) return;
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "WARNA_LOG.xlsx";
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.log("error: ", error);
        }
    };

    handlePrint = async () => {
      const { setError } = this.props;
      this.handleTriggerLoading();
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA_FILE")
          .downloadWarnaSegmentExcel,
        setError: setError,
        menuName: "Master Logistik Motor - Warna",
      });
      this.handleTriggerLoading();
      if (res.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "Master_Logistik_Motor_Warna_.xlsx");
      }
    };

    render() {
        return (
            <>
                <FlexView
                    style={{justifyContent: "space-between"}}
                    className="margin-bottom-5px margin-top-5px"
                >
                    <FlexView vAlignContent="center" className="margin-bottom-5px">
                        <SimpleInput
                            type="text"
                            name="kodeVariant"
                            onChange={(e) => this.handleSearchValueChange(e.target.name, e.target.value)}
                            value={this.state.search.kodeVariant}
                            placeholder="Kode Varian"
                            containerclassname="margin-bottom-none"
                        />
                        <SimpleButton onClick={this.handleSearch} className="margin-top-5px">Cari</SimpleButton>
                    </FlexView>
                    <Button
                        type="button"
                        className="margin-top-5px btn background-red"
                        onClick={this.handleModalFilterVisibility}
                    >
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
                    </Button>
                </FlexView>
                <MasterLogistikTable
                    tableConfig={this.tableConfig}
                    menuAccess={this.props.menuAccess}
                    data={this.state.dataTable}
                    onEdit={this.handleModifyingModalVisibility}
                    onChangeStatus={this.handleChangeStatus}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    pagination={this.state.pagination}
                    additionalButtons={
                        <FlexView vAlignContent="center">
                            {
                                this.props.menuAccess && this.props.menuAccess.createAccess && (
                                    <SimpleButton
                                        onClick={() => this.handleModifyingModalVisibility()}
                                        icon={<i className="fa fa-plus margin-right-10px"></i>}
                                        text={"Tambah"}
                                    />
                                )
                            }
                            <SimpleButton
                                text="Cetak"
                                onClick={() => this.handlePrint()}
                            />
                            <SimpleButton
                                text="Upload"
                                onClick={() => this.handleUploadModalVisibility()}
                            />
                        </FlexView>
                    }
                />

                {this.state.modifyingVisible && (
                    <MasterLogistikMotorWarnaModifying
                        formGroup={formGroupWarna}
                        initialValues={this.state.selectedData}
                        selectedData={this.state.selectedData}
                        dataVariantDDL={this.state.dataVariantDDL}
                        visible={this.state.modifyingVisible}
                        onSubmit={this.handleSubmitModifying}
                        onClickClose={this.handleModifyingModalVisibility}
                    />
                )}

                {this.state.filterModalVisible && (
                    <MasterLogistikMotorWarnaFilter
                        selectedData={this.state.filterData}
                        visible={this.state.filterModalVisible}
                        onSubmit={this.handleSubmitFilter}
                        onValueChange={this.handleFilterValueChange}
                        onClearForm={this.handleClearForm}
                        onClickClose={this.handleModalFilterVisibility}
                    />
                )}

                {this.state.uploadModalVisible && (
                    <SimpleUploadExcel
                        downloadError={true}
                        visible={this.state.uploadModalVisible}
                        onDownloadTemplate={this.handleDownloadTemplate}
                        onDownloadLogError={this.handleDownloadLogError}
                        onChange={this.handleUpload}
                        onClickClose={this.handleUploadModalVisibility}
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

export default MasterLogistikMotorWarna;
